// ============================================================
// HOW THE MAP IS DRAWN, as one object
// ============================================================

import { CAMERA_PRESETS } from '../../engine/battlefield/projection';

/**
 * The View panel's settings and camera actions, bundled rather than
 * threaded as fifteen props: the View panel is a single consumer, and the
 * alternative is a component signature nobody can read. Nothing here is
 * state of its own - every entry is a viewer preference (`prefs`, from
 * useMapPrefs), the table's terrain switch, or a camera action.
 */
export function viewOptionsOf(prefs, { ignoreTerrain, onIgnoreTerrainChange }, { applyPreset, reset }) {
  return {
    showLabels: prefs.showLabels,
    toggleLabels: prefs.toggleLabels,
    ignoreTerrain,
    onIgnoreTerrainChange,
    autoTarget: prefs.autoTarget,
    toggleAutoTarget: prefs.toggleAutoTarget,
    hoverInfo: prefs.hoverInfo,
    toggleHoverInfo: prefs.toggleHoverInfo,
    hoverDetail: prefs.hoverDetail,
    toggleHoverDetail: prefs.toggleHoverDetail,
    showPings: prefs.showPings,
    toggleShowPings: prefs.toggleShowPings,
    terrainMarks: prefs.terrainMarks,
    toggleTerrainMarks: prefs.toggleTerrainMarks,
    terrainAnimation: prefs.terrainAnimation,
    setTerrainAnimation: prefs.setTerrainAnimation,
    markerStatus: prefs.markerStatus,
    setMarkerStatus: prefs.setMarkerStatus,
    cameraPresets: CAMERA_PRESETS,
    applyPreset,
    resetCamera: reset,
  };
}
